import { Skeleton, SkeletonRows } from '@orgus/ui';

/** The Overview's shape while the first state loads: the glance strip, projects beside Needs you, then activity. */
export function OverviewSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-(--layout-width-dashboard) flex-col gap-6" role="status" aria-label="Loading the overview">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="flex flex-col gap-2 rounded-card border border-border bg-surface px-4 py-3 shadow-elevation-flat">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-6 w-12" />
            <Skeleton className="h-3 w-24" />
          </div>
        ))}
      </div>
      <div className="grid items-start gap-6 xl:grid-cols-12">
        <div className="rounded-card border border-border bg-surface shadow-elevation-flat xl:col-span-7">
          <div className="h-12" />
          <SkeletonRows rows={5} />
        </div>
        <div className="rounded-card border border-border bg-surface shadow-elevation-flat xl:col-span-5">
          <div className="h-12" />
          <SkeletonRows rows={6} />
        </div>
      </div>
    </div>
  );
}
